<div class="time-elapsed__wrapper">
  <ng-container *ngIf="timer$ | async as timer">
    <div class="w-100 overflow-hidden">
      <div class="widget__text--small text-truncate mb-md-1 mb-lg-2">Time Elapsed</div>
      <div class="widget__text--large text-truncate">{{timer.hours | number:'2.0-0'}}:{{timer.minutes | number:'2.0-0'}}:{{timer.seconds | number:'2.0-0'}}</div>
    </div>
  </ng-container>
  <app-icon-time-elapsed></app-icon-time-elapsed>
</div>